import React, { useState } from 'react';
import { 
  User, 
  Bike, 
  Car, 
  Train, 
  ChevronDown,
  Footprints
} from 'lucide-react';

const TransportModeSelector = ({ currentMode, onModeChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const transportModes = [
    { id: 'walking', name: 'Walking', icon: Footprints, color: '#ff4444' },
    { id: 'running', name: 'Running', icon: User, color: '#ff8800' },
    { id: 'biking', name: 'Biking', icon: Bike, color: '#44aa44' },
    { id: 'driving', name: 'Driving', icon: Car, color: '#4444ff' },
    { id: 'transit', name: 'Transit', icon: Train, color: '#8844ff' }
  ];

  const currentModeData = transportModes.find(mode => mode.id === currentMode) || transportModes[0];

  const handleModeSelect = (modeId) => {
    onModeChange(modeId);
    setIsOpen(false);
  };

  return (
    <div className="absolute top-4 left-4 z-10">
      <div className="relative">
        {/* Main Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="p-3 rounded-full bg-white/90 backdrop-blur-sm border border-gray-200 shadow-lg hover:bg-white hover:shadow-xl transition-all duration-200 flex items-center space-x-2"
        >
          <currentModeData.icon 
            className="w-6 h-6" 
            style={{ color: currentModeData.color }}
          />
          <ChevronDown className="w-4 h-4 text-gray-600" />
        </button>

        {/* Dropdown Menu */}
        {isOpen && (
          <div className="absolute top-full left-0 mt-2 bg-white rounded-lg shadow-lg border border-gray-200 min-w-[180px] z-20">
            <div className="py-2">
              {transportModes.map((mode) => (
                <button
                  key={mode.id}
                  onClick={() => handleModeSelect(mode.id)}
                  className={`w-full px-4 py-3 text-left hover:bg-gray-50 flex items-center space-x-3 transition-colors ${
                    currentMode === mode.id ? 'bg-indigo-50 text-indigo-700' : 'text-gray-700'
                  }`}
                >
                  <mode.icon 
                    className="w-5 h-5" 
                    style={{ color: mode.color }}
                  />
                  <span className="font-medium">{mode.name}</span>
                  {currentMode === mode.id && (
                    <div className="ml-auto w-2 h-2 bg-indigo-600 rounded-full"></div>
                  )}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Overlay to close dropdown when clicking outside */}
      {isOpen && (
        <div
          className="fixed inset-0 z-10"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default TransportModeSelector;
